import moment from "moment";
import axios from "axios";
const changeUserAction = async (
  formState,
  setSuccessMessage,
  setErrorMessage
) => {
  const formattedPayload = {
    User: formState?.User,
    Vendor : formState?.Vendor.Vendor_Code
  };
  
  await axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/UpsertUrgentVendorIR`,
    data : formattedPayload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
   
  })
    .then(async (res) => {
      console.log(res, "response");
      // setChangeUserLoading(false);
      setSuccessMessage(res.data.message);
      // updateForm();
      // setWaitMessage("");
      // setSelectedUser("")
      // setComment("")
    })
    .catch((err) => {
      console.log(err.response.data, "error");
      setErrorMessage(err.response.data);
    });
};

const getChangeUserInvoicesLandingPage = async (
  setInvoices,
  setInvoiceLoading,
  invoiceData,
  setCount,
  status,
  isOrderUpdated
) => {
  setInvoices([]);
  const stringified = JSON.stringify(invoiceData);
  const parsed = JSON.parse(stringified);
  let data = parsed;
  console.log(data,'parsed data')
    data.Vendor = parsed.Vendor?.Vendor_Code || parsed.vendor_Code?.Vendor_Code;
  // data.Status = parsed?.Status?.text

  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/getUsersByVendorCode/${data.Vendor}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // params: data,
    // data: data,
  })
    .then(async (res) => {
      console.log(res, "response");
      setInvoices(res?.data);
      // setCount(parseInt(res?.data?.recordsCount));
      setInvoiceLoading(false);
    })
    .catch((err) => {
      setInvoices([]);
      setInvoiceLoading(false);
    });
};

export { changeUserAction, getChangeUserInvoicesLandingPage };
